(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8797],{

/***/ 16837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ UploadsAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24196);



var uploadImageToUGCBucket = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.postFile */ .b.postFile("/v1/images", "img", file)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        "".concat("https://db2ui4bhd59ll.cloudfront.net").concat(response.img_url)
                    ];
            }
        });
    });
    return function uploadImageToUGCBucket(file) {
        return _ref.apply(this, arguments);
    };
}();
var uploadImageToCMSBucket = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.postFile */ .b.postFile("/v1/cms-images", "img", file)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        "".concat("https://d2qpirhrfplx04.cloudfront.net").concat(response.img_url)
                    ];
            }
        });
    });
    return function uploadImageToCMSBucket(file) {
        return _ref.apply(this, arguments);
    };
}();
var uploadImageToCoursesBucket = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.postFile */ .b.postFile("/v1/courses-images", "img", file)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.img_url.replace("/learning_paths/", "")
                    ];
            }
        });
    });
    return function uploadImageToCoursesBucket(file) {
        return _ref.apply(this, arguments);
    };
}();
var uploadProfileImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.postFile */ .b.postFile("/v1/profile-image", "img", file)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        "".concat("https://d3erjy8u3ir82s.cloudfront.net").concat(response.img_url)
                    ];
            }
        });
    });
    return function uploadProfileImage(file) {
        return _ref.apply(this, arguments);
    };
}();
var uploadUserNoteBook = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.postFile */ .b.postFile("/v1/user-submission-notebook", "ipynb", file)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.notebook_url
                    ];
            }
        });
    });
    return function uploadUserNoteBook(file) {
        return _ref.apply(this, arguments);
    };
}();
var UploadsAPI = {
    uploadImageToUGCBucket: uploadImageToUGCBucket,
    uploadImageToCMSBucket: uploadImageToCMSBucket,
    uploadProfileImage: uploadProfileImage,
    uploadImageToCoursesBucket: uploadImageToCoursesBucket,
    uploadUserNoteBook: uploadUserNoteBook
};


/***/ }),

/***/ 19546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bd": function() { return /* binding */ getSeniorityYOEString; },
/* harmony export */   "F5": function() { return /* binding */ convertObjectToQueryString; },
/* harmony export */   "Nq": function() { return /* binding */ getPositionString; },
/* harmony export */   "SH": function() { return /* binding */ getUrlPrefix; },
/* harmony export */   "b9": function() { return /* binding */ getCompanyOrDMAString; }
/* harmony export */ });
var getPositionString = function(page) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        seniority: true
    };
    if (page.dma_name) return "".concat(page.position_name, " in ").concat(page.dma_name);
    if (page.company_name) return "".concat(page.position_name, " at ").concat(page.company_name);
    if (page.seniority_name && options.seniority) return "".concat(page.seniority_name, " ").concat(page.position_name);
    return page.position_name;
};
var getCompanyOrDMAString = function(page) {
    if (page.dma_name) return "in ".concat(page.dma_name);
    if (page.company_name) return "at ".concat(page.company_name);
};
var getSeniorityYOEString = function(minYOE, maxYOE) {
    if (maxYOE) return "".concat(minYOE || 0, "-").concat(maxYOE, " years of experience");
    if (minYOE) return "".concat(minYOE, "+ years of experience");
};
var convertObjectToQueryString = function(obj) {
    return Object.keys(obj).map(function(key) {
        return "".concat(key, "=").concat(obj[key]);
    }).join("&");
};
var getUrlPrefix = function(type) {
    switch(type){
        case "articles":
            return "p";
        case "salaries":
            return "salaries";
        case "interviews":
            return "interview-guides";
        default:
            throw new Error("Unknown cms page type: ".concat(type));
    }
};


/***/ }),

/***/ 3232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ MainCourseCTA; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/learning_path.ts
var learning_path = __webpack_require__(86815);
// EXTERNAL MODULE: ./src/api/tracking.ts
var tracking = __webpack_require__(5123);
// EXTERNAL MODULE: ./src/components/system/checkbox.tsx
var system_checkbox = __webpack_require__(77388);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/learning_path/simple_course_section_list.module.css
var simple_course_section_list_module = __webpack_require__(95393);
var simple_course_section_list_module_default = /*#__PURE__*/__webpack_require__.n(simple_course_section_list_module);
;// CONCATENATED MODULE: ./src/components/learning_path/simple_course_section_list.tsx





var CourseSectionList = function(param) {
    var _sections = param.sections, sections = _sections === void 0 ? [] : _sections, learningPathSlug = param.learningPathSlug, courseSlug = param.courseSlug;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: sections.map(function(section) {
            var uuid = section.uuid, title = section.title, sub_description = section.sub_description, is_completed = section.is_completed, slug = section.slug;
            var trackSectionClick = function(e) {
                return tracking/* TrackingAPI.courseLinkClicked */.A.courseLinkClicked(section);
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    prefetch: false,
                    href: "/learning-paths/".concat(learningPathSlug, "/").concat(courseSlug, "/").concat(slug),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (simple_course_section_list_module_default()).linkWrapper,
                            onClick: trackSectionClick,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (simple_course_section_list_module_default()).alignLayout,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(system_checkbox/* Checkbox */.X, {
                                            value: is_completed
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (simple_course_section_list_module_default()).link,
                                            children: title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (simple_course_section_list_module_default()).time,
                                    children: "(".concat(sub_description, ")")
                                })
                            ]
                        })
                    })
                })
            }, "cs-".concat(title));
        })
    });
};

// EXTERNAL MODULE: ./src/components/system/button.tsx
var system_button = __webpack_require__(4642);
// EXTERNAL MODULE: ./src/components/system/content_placeholder.tsx
var content_placeholder = __webpack_require__(62836);
// EXTERNAL MODULE: ./src/components/system/divider.tsx
var divider = __webpack_require__(34070);
// EXTERNAL MODULE: ./src/components/system/latex.tsx
var latex = __webpack_require__(89795);
// EXTERNAL MODULE: ./src/components/system/progress_bar.tsx
var progress_bar = __webpack_require__(72104);
// EXTERNAL MODULE: ./src/components/system/text_container.tsx
var text_container = __webpack_require__(70865);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/dashboard/plan/main_course_cta.module.css
var main_course_cta_module = __webpack_require__(65082);
var main_course_cta_module_default = /*#__PURE__*/__webpack_require__.n(main_course_cta_module);
;// CONCATENATED MODULE: ./src/components/dashboard/plan/main_course_cta_fallback_image.tsx


var COURSE_IMAGES_BUCKET = "https://d21btiopftpazk.cloudfront.net";
var LearningPathThumbnail = function(param) {
    var course = param.course, currentSection = param.currentSection;
    var thumbnailImage = (0,react.useMemo)(function() {
        if (course) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(currentSection.content, "text/html");
            var iframe = doc.querySelector("iframe");
            if (iframe && iframe.src.indexOf("youtube") !== -1) {
                return "https://img.youtube.com/vi/".concat(iframe.src.split("/").pop(), "/0.jpg");
            }
            var img = doc.querySelector("img");
            if (img && img.src) {
                return img.src;
            }
            if (course.img_url) return "".concat(COURSE_IMAGES_BUCKET, "/learning_paths/").concat(course.img_url);
            if (course.learning_path_img) return "".concat(COURSE_IMAGES_BUCKET, "/learning_paths/").concat(course.learning_path_img);
            return getFallbackImageForTopicOfInterest(course, currentSection);
        }
    }, [
        course,
        currentSection
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        width: 280,
        height: 160,
        src: thumbnailImage,
        alt: course === null || course === void 0 ? void 0 : course.title
    });
};
var getFallbackImageForTopicOfInterest = function(course, currentSection) {
    switch(course.topic_of_interest){
        case "sql":
            return getSignedImage(COURSE_IMAGE_FALLBACK.sql, currentSection.uuid);
        case "product metrics":
            return getSignedImage(COURSE_IMAGE_FALLBACK.product, currentSection.uuid);
        case "ml system design":
            return getSignedImage(COURSE_IMAGE_FALLBACK.ml, currentSection.uuid);
        case "statistics":
        case "probability":
            return getSignedImage(COURSE_IMAGE_FALLBACK.statistics, currentSection.uuid);
        case "python":
            return getSignedImage(COURSE_IMAGE_FALLBACK.code, currentSection.uuid);
        default:
            return "/img/logo.svg";
    }
};
var getSignedImage = function(array, currentLessonUUID) {
    var indexForCourse = getSignature(currentLessonUUID, array.length);
    return "".concat("https://d2qpirhrfplx04.cloudfront.net", "/").concat(array[indexForCourse]);
};
// Minimalistic hash function that makes that the same uuid, always gets the same image
var getSignature = function(str, N) {
    var hash = 0, i, chr;
    if (str.length === 0) return hash;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return Math.abs(hash) % N;
};
var COURSE_IMAGE_FALLBACK = {
    code: [
        "b8767352-b373-48fc-b73d-bd846f482a87.webp",
        "50328ed4-45c6-458b-aff7-b5753c000dc8.webp",
        "cd58de06-422b-41d1-862d-d3907d6b3e5f.webp",
        "ffe2dc1e-45d0-4c2a-add6-9fa97fb8f791.webp",
        "8379cf8e-5db7-483b-bc85-bc45f31888f7.webp",
        "5503e341-9635-4b6f-8110-fbd87351cd1a.webp",
        "82b8fc8c-d75a-43cd-b1c5-8d8f834a2c88.webp",
        "c3383453-d808-458c-9b42-6e6f119e661c.webp",
        "f10d585c-51a1-4eda-836e-42362a24ab96.webp",
        "b030e3cf-fdb6-46f2-aada-2209743ab669.webp",
        "c07c5aad-0d7c-40bb-b7a8-6ef4d4b982c0.webp",
        "5a8997da-4793-41ab-a5d8-3e08e86238fa.webp",
        "42c3d769-27c0-455c-9ec7-3a72ef8c64bd.webp",
        "ab9f1864-b42b-4651-86a9-14124dc536e4.webp",
        "120b4dc0-d549-4ee2-bd39-ebc836bed5ea.webp", 
    ],
    ml: [
        "dc624ad8-431d-45ac-9818-7abc742e3517.webp",
        "dd06dbe6-d578-409e-821d-1dafcc5d7610.webp",
        "2d6132e2-317d-467f-82ec-e33b0ae5bf9c.webp",
        "c5d3581c-410e-460b-b721-a4fb7e614e2b.webp",
        "32d822d4-cc2a-4884-b70b-956429f1805a.webp",
        "885d868a-b61a-4002-a38d-c9a93450cdea.webp",
        "f612b3a7-9f7b-4b3d-bbc2-56de311a357b.webp",
        "730b8669-98cf-4008-a9a5-63c749628d80.webp",
        "b9b3d3e9-80e3-4e2c-9440-da065a2dd1ed.webp",
        "91825929-82b4-447e-94a9-f550ca3521b6.webp",
        "ee9525d3-3613-459e-9849-d2999bf0242e.webp",
        "6302be93-7a4c-4336-a774-618f11e7f32d.webp",
        "5eb9e85b-59af-4ff0-84e0-4f0526fdf431.webp",
        "e4597bd3-9abd-4f0a-895a-f4cc9dee57e1.webp",
        "6e3c34e6-9962-4733-a8da-5a72af8b65ad.webp",
        "123a8199-11cd-4bbd-977e-376f393a43d9.webp",
        "9fea5c4c-6d7d-49ca-9528-c5e4b1f393bb.webp",
        "f6a9e678-04d0-4e2e-9910-64eca14d9233.webp",
        "c2d1b2d0-537e-4830-93cc-4843018bd5cd.webp",
        "a4be65ed-2844-45c7-85e4-d25e123f2ff4.webp",
        "d82656e1-8038-45fd-b75b-c0ebeaded009.webp", 
    ],
    product: [
        "ed3e3b7c-a52a-4864-b72a-dfc4d04218fa.webp",
        "78615276-7174-4914-b343-823ac018e16c.webp",
        "565f4d04-f70d-486c-b91b-22337dc3308e.webp",
        "503af8e0-3b21-43b3-9cc4-593325e400ff.webp",
        "b30aa93b-8b41-46c8-98af-907fd2c9d37c.webp",
        "450ffd55-fbaf-4334-9db9-c01daf4eca75.webp",
        "31d19848-2e93-4f77-9429-1e39f6abbe6f.webp",
        "8165c69f-0e94-4b41-bbff-11df4829e78f.webp",
        "2bbda2e2-89af-4f7e-b375-5bca9f2d169a.webp",
        "fd70b2ac-e89a-4ce5-8a56-a62458ce4c2c.webp",
        "e7dcd006-1b48-4f36-8d84-3183f1971995.webp",
        "7d893365-2f67-4c48-ab37-d12a8e5c27aa.webp",
        "d1ea7806-a062-4383-b30a-67ef886abedd.webp",
        "1f3d5eda-9da4-4dff-9854-4400ca2be0a5.webp",
        "dd65fd81-4f35-4f55-aa19-017bb97919e0.webp", 
    ],
    sql: [
        "4f2bfdb4-d880-4713-8340-08123cd95062.webp",
        "2d91ea29-e253-4af0-83a0-e3174cd15683.webp",
        "c2d543a1-cdce-4d1a-96aa-4c8bae44b0de.webp",
        "07917a00-8f1f-428c-b532-ca1eb99e13d5.webp",
        "36096ccf-7c1a-4a6a-b2e1-6b95cd53a6e4.webp",
        "915a3f9b-d13e-4ea6-8663-c2700ed2944f.webp",
        "ff30c65d-e659-4de5-a748-3386338a659e.webp",
        "ae1cd618-4927-43cf-b937-69308b779c4a.webp",
        "bad36c8d-48b3-409e-ae74-1fafa8e3e9b9.webp",
        "364e55ea-73fa-4ac5-a6d8-7430416e3956.webp",
        "f1ab3b63-7a06-4128-b6d2-ad1dc8a1e993.webp",
        "1d2c2f4f-aea5-43ec-8072-70620049ee69.webp",
        "0d8c6375-cbf4-4de9-a5c8-ab6aa068b56e.webp",
        "003e8c67-7bc2-4dd0-8304-17f19b70cb8e.webp",
        "0a1ed66c-82c3-4074-9c5f-0c9c0cf81885.webp", 
    ],
    statistics: [
        "495cdc67-6dcf-4447-b83d-1cf44075a6a0.webp",
        "0c00a625-693d-4011-a20d-7a3111c19aac.webp",
        "cc18a163-9595-4c8e-9776-a7147e2d7170.webp",
        "5f5fa48d-93ac-499a-968a-8554387d4509.webp",
        "ef62138b-5fb4-4475-8f43-b9f2dc676508.webp",
        "36572ad5-d5e9-4372-875c-519379fadd9a.webp",
        "d4b8b6dc-eaa4-4192-b3b4-c5180ed230b6.webp",
        "978db4ba-b6e0-4577-969a-2ff9343aa93d.webp",
        "d62ae045-36c0-4e9c-b934-275f92d97537.webp",
        "0208519a-2352-4e5f-ae44-7269f5ea074a.webp",
        "955387a3-2d22-4528-8b6d-482af3a448d8.webp",
        "1961b588-e6df-4ed1-bdc8-64fc96decd98.webp",
        "ad6ee5d7-1b85-43f0-bc67-e7ba6435d41f.webp",
        "dee60d01-0680-4cb0-8ada-40449ec5f7ab.webp", 
    ]
};

;// CONCATENATED MODULE: ./src/components/dashboard/plan/main_course_cta.tsx















var MainCourseCTA = function(param) {
    var courseUUID = param.courseUUID, _reload = param.reload, reload = _reload === void 0 ? true : _reload, _collapsible = param.collapsible, collapsible = _collapsible === void 0 ? false : _collapsible;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(null), course = ref1[0], setCourse = ref1[1];
    var ref2 = (0,react.useState)(collapsible), collapsed = ref2[0], setCollapsed = ref2[1];
    var COURSE_IMAGES_BUCKET = "https://d21btiopftpazk.cloudfront.net";
    var currentSection = (0,react.useMemo)(function() {
        if (course && course.sections) {
            var completed = course.sections.filter(function(section) {
                return section.is_completed;
            }).sort(function(a, b) {
                return new Date(b.last_viewed_at).getTime() - new Date(a.last_viewed_at).getTime();
            });
            if (completed.length === 0) {
                return course === null || course === void 0 ? void 0 : course.sections[0];
            }
            return completed[0];
        }
    }, [
        course
    ]);
    (0,react.useEffect)(function() {
        var loadCourse = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var rec, rec1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!courseUUID) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                learning_path/* LearningPathAPI.getCourseChapterByUUID */.E.getCourseChapterByUUID(courseUUID)
                            ];
                        case 1:
                            rec = _state.sent();
                            setCourse(rec);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                learning_path/* LearningPathAPI.getCourseChapterRecommendations */.E.getCourseChapterRecommendations()
                            ];
                        case 3:
                            rec1 = _state.sent();
                            setCourse(rec1);
                            _state.label = 4;
                        case 4:
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadCourse() {
                return _ref.apply(this, arguments);
            };
        }();
        if (reload) {
            loadCourse();
        }
    }, [
        reload
    ]);
    var getProgress = function() {
        if (!course || !course.sections) return 0;
        var progress = course.sections.filter(function(section) {
            return section.is_completed;
        }).length / (course === null || course === void 0 ? void 0 : course.sections.length);
        return progress !== null && progress !== void 0 ? progress : 0;
    };
    var renderContent = function(section) {
        if (section.sub_description.toLowerCase().indexOf("video") !== -1) {
            return "Video";
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_container/* TextContainer */.l, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(latex/* Latex */.r, {
                children: section.content
            })
        });
    };
    if (!course || !course.sections) return null;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_placeholder/* ContentPlaceholder */.r, {});
    var remainingSections = course.sections.filter(function(section) {
        return !section.is_completed;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (main_course_cta_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (main_course_cta_module_default()).titleDivHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        width: 30,
                        height: 30,
                        src: "".concat(COURSE_IMAGES_BUCKET, "/learning_paths/").concat(course.learning_path_img),
                        alt: course.learning_path_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        children: [
                            "(",
                            course.learning_path_title,
                            ") Learning Path"
                        ]
                    })
                ]
            }),
            currentSection && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    remainingSections.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "You only have ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                children: [
                                    remainingSections.length,
                                    " lessons"
                                ]
                            }),
                            " remaining in",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: course.title
                            }),
                            " course. Currently you are on",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: currentSection.title
                            }),
                            "."
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "You have finished all sections in ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: course.title
                            }),
                            " course."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_bar/* ProgressBar */.k, {
                        progress: getProgress(),
                        color: "green"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (main_course_cta_module_default()).imageWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LearningPathThumbnail, {
                                course: course,
                                currentSection: currentSection
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (main_course_cta_module_default()).description,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: currentSection.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (main_course_cta_module_default()).contentPreview,
                                        children: renderContent(currentSection)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                                        onClick: function() {
                                            router.push("/learning-paths/".concat(course.learning_path_slug, "/").concat(course.slug, "/").concat(currentSection.slug));
                                        },
                                        children: "Continue Lesson"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            remainingSections.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(system_button/* Button */.z, {
                size: "sm",
                type: "outline",
                color: "greyMedium",
                onClick: function() {
                    return setCollapsed(!collapsed);
                },
                children: [
                    collapsed ? "view" : "hide",
                    " remaining sections in this course"
                ]
            }),
            !collapsed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* Divider */.i, {
                        size: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseSectionList, {
                        courseSlug: course.slug,
                        sections: course.sections.filter(function(section) {
                            return !section.is_completed;
                        }),
                        learningPathSlug: course.learning_path_slug
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 49998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ PostCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var api_content_upvotes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68908);
/* harmony import */ var api_discussion_board__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24332);
/* harmony import */ var api_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5123);
/* harmony import */ var components_discussion_board_contribute_post_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62412);
/* harmony import */ var components_discussion_board_moderate_post__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9753);
/* harmony import */ var components_system_async_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81715);
/* harmony import */ var components_system_between_dots__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16917);
/* harmony import */ var components_system_pilltag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94390);
/* harmony import */ var components_system_pilltag_group__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8681);
/* harmony import */ var components_system_profile_image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89825);
/* harmony import */ var components_system_timestamp__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76778);
/* harmony import */ var components_system_vote__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89049);
/* harmony import */ var icons_lock__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(64239);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67294);
/* harmony import */ var users__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(95575);
/* harmony import */ var _post_card_module_css__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(28325);
/* harmony import */ var _post_card_module_css__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_post_card_module_css__WEBPACK_IMPORTED_MODULE_17__);




















var PostCard = function(param) {
    var post = param.post, _showVote = param.showVote, showVote = _showVote === void 0 ? true : _showVote, _showModeration = param.showModeration, showModeration = _showModeration === void 0 ? true : _showModeration, onDelete = param.onDelete;
    var ref = (0,users__WEBPACK_IMPORTED_MODULE_16__/* .useAuth */ .aC)(), user = ref.user, hasPermission = ref.hasPermission;
    var showUpsellModal = (0,users__WEBPACK_IMPORTED_MODULE_16__/* .useUpsell */ .$n)().showUpsellModal;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_15__.useState)(false), locked = ref1[0], setLocked = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_15__.useEffect)(function() {
        setLocked(!hasPermission("locked_post_view", post.slug));
    }, [
        user,
        post
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_post_card_module_css__WEBPACK_IMPORTED_MODULE_17___default().container),
        children: [
            showVote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_vote__WEBPACK_IMPORTED_MODULE_12__/* .Vote */ .A, {
                upvotes: post.upvotes,
                userVote: post.user_vote,
                onVote: function(vote) {
                    return api_content_upvotes__WEBPACK_IMPORTED_MODULE_1__/* .ContentUpvotesAPI.upvotePost */ .S.upvotePost(post.uuid, vote);
                },
                disabled: post.author_identifier === user.uuid,
                layout: "vertical"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_post_card_module_css__WEBPACK_IMPORTED_MODULE_17___default().content),
                children: [
                    showModeration && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_discussion_board_moderate_post__WEBPACK_IMPORTED_MODULE_5__/* .ModeratePost */ .A, {
                        post: post
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                        prefetch: false,
                        href: "/discuss/".concat(post.topic_slug, "/posts/").concat(post.slug),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            onClick: function(e) {
                                if (post.topic.is_locked && !hasPermission("locked_post_view", post.slug)) {
                                    e.preventDefault();
                                    showUpsellModal({
                                        sourceObject: post,
                                        cta: "post.openLockedPost",
                                        ctaParams: {
                                            topic: post.topic.name.toLowerCase()
                                        },
                                        extraActions: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_discussion_board_contribute_post_link__WEBPACK_IMPORTED_MODULE_4__/* .ContributePostLink */ .O, {
                                            post: post
                                        })
                                    });
                                }
                                api_tracking__WEBPACK_IMPORTED_MODULE_3__/* .TrackingAPI.discussionListModuleViewed */ .A.discussionListModuleViewed({
                                    action: "click",
                                    extra_data: {
                                        topic: post.topic.name,
                                        post_name: post.subject,
                                        content_identifier: post.uuid
                                    }
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_post_card_module_css__WEBPACK_IMPORTED_MODULE_17___default().header),
                                    children: [
                                        locked && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(icons_lock__WEBPACK_IMPORTED_MODULE_13__/* .LockIcon */ .m, {}),
                                        post.subject
                                    ]
                                }),
                                post.body_preview && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: post.body_preview
                                })
                            ]
                        })
                    }),
                    post.tags.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_pilltag_group__WEBPACK_IMPORTED_MODULE_9__/* .PillTagGroup */ .s, {
                        children: post.tags.map(function(tag) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_pilltag__WEBPACK_IMPORTED_MODULE_8__/* .PillTag */ .j, {
                                children: tag.keyword
                            }, tag.keyword);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_system_between_dots__WEBPACK_IMPORTED_MODULE_7__/* .BetweenDots */ .A, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_profile_image__WEBPACK_IMPORTED_MODULE_10__/* .ProfileImage */ .m, {
                                displayName: post.author,
                                url: post.author_img,
                                isAnonymous: post.is_anonymous
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: post.is_anonymous ? "Anonymous" : post.author
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_timestamp__WEBPACK_IMPORTED_MODULE_11__/* .FormatShortDate */ .U, {
                                    children: post.created_at
                                })
                            }),
                            !showVote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    post.upvotes,
                                    " upvote",
                                    post.upvotes === 1 ? "" : "s"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    post.comment_count,
                                    " comment",
                                    post.comment_count === 1 ? "" : "s"
                                ]
                            }),
                            (hasPermission("post_admin") || post.author === user.username) && onDelete && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_async_button__WEBPACK_IMPORTED_MODULE_6__/* .AsyncButton */ .Z, {
                                type: "text",
                                color: "greyDark",
                                onRequest: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    api_discussion_board__WEBPACK_IMPORTED_MODULE_2__/* .DiscussionBoardAPI.deletePost */ .y.deletePost(post)
                                                ];
                                            case 1:
                                                _state.sent();
                                                hasPermission("post_admin") && api_tracking__WEBPACK_IMPORTED_MODULE_3__/* .TrackingAPI.modAction */ .A.modAction("delete_post", user, post.uuid, post);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                onSuccess: function() {
                                    return onDelete(post);
                                },
                                children: "Delete"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 87834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ QuestionLinkList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_system_pilltag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94390);
/* harmony import */ var components_system_pilltag_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8681);
/* harmony import */ var icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37870);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var types_levels__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38194);
/* harmony import */ var _question_link_list_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85285);
/* harmony import */ var _question_link_list_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_6__);








var QuestionLinkList = function(param) {
    var questions = param.questions;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_6___default().container),
        children: questions.map(function(question) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuestionLink, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, question), question.slug);
        })
    });
};
var QuestionLink = function(param) {
    var slug = param.slug, title = param.title, summary = param.summary, tags = param.tags, level = param.level;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
        prefetch: false,
        href: "/questions/".concat(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: (_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_6___default().link),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_6___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: title
                        }),
                        summary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: summary
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_system_pilltag_group__WEBPACK_IMPORTED_MODULE_2__/* .PillTagGroup */ .s, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_pilltag__WEBPACK_IMPORTED_MODULE_1__/* .PillTag */ .j, {
                                    color: types_levels__WEBPACK_IMPORTED_MODULE_5__/* .difficultyLevelColors */ .gw[level],
                                    children: types_levels__WEBPACK_IMPORTED_MODULE_5__/* .difficultyLevelNames */ .vz[level]
                                }),
                                (tags || []).map(function(tag) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_pilltag__WEBPACK_IMPORTED_MODULE_1__/* .PillTag */ .j, {
                                        color: "greyLight",
                                        children: tag.name
                                    }, tag.id);
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(icons__WEBPACK_IMPORTED_MODULE_3__/* .ChevronRightIcon */ .XC, {})
            ]
        })
    });
};


/***/ }),

/***/ 62836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ContentPlaceholder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5306);
/* harmony import */ var _content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1__);



var ContentPlaceholder = function(param) {
    var _lines = param.lines, lines = _lines === void 0 ? 5 : _lines;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1___default().container),
        children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Array(lines).keys()).map(function(_, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1___default().line)
            }, index);
        })
    });
};


/***/ }),

/***/ 89795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Latex; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var katex_dist_katex_min_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97604);
/* harmony import */ var katex_dist_katex_min_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(katex_dist_katex_min_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_latex_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30760);




var Latex = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_latex_next__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};


/***/ }),

/***/ 72104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ProgressBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44868);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47655);
/* harmony import */ var _progress_bar_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51733);
/* harmony import */ var _progress_bar_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_progress_bar_module_css__WEBPACK_IMPORTED_MODULE_3__);




var ProgressBar = function(param) {
    var progress = param.progress, _color = param.color, color = _color === void 0 ? "blue" : _color, _size = param.size, size = _size === void 0 ? "sm" : _size;
    var background;
    if (color === "dynamic") {
        if (progress < 0.2) background = "red";
        else if (progress < 0.4) background = "orangeLight";
        else if (progress < 0.6) background = "orange";
        else if (progress < 0.8) background = "blueLight";
        else background = "blue";
    } else {
        background = color;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,utils__WEBPACK_IMPORTED_MODULE_2__/* .classNames */ .AK)([
            (_progress_bar_module_css__WEBPACK_IMPORTED_MODULE_3___default().track),
            (_progress_bar_module_css__WEBPACK_IMPORTED_MODULE_3___default())[size]
        ]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,utils__WEBPACK_IMPORTED_MODULE_2__/* .classNames */ .AK)([
                (_progress_bar_module_css__WEBPACK_IMPORTED_MODULE_3___default().progress),
                (_progress_bar_module_css__WEBPACK_IMPORTED_MODULE_3___default())[size]
            ]),
            style: {
                width: "".concat(Math.min(progress * 100, 100), "%"),
                background: _colors__WEBPACK_IMPORTED_MODULE_1__/* .cssColorValues */ .b[background]
            }
        })
    });
};


/***/ }),

/***/ 64239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ LockIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_system_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47655);


var LockIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? "greyDark" : _color, _width = param.width, width = _width === void 0 ? "24" : _width, _height = param.height, height = _height === void 0 ? "24" : _height, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.50654 6.88683C8.89106 7.30158 8.6 7.81071 8.6 8.29545V12.3386H7.4V8.29545C7.4 7.29096 8.00394 6.45236 8.83596 5.89169C9.67151 5.32864 10.7919 5 12 5C13.2081 5 14.3285 5.32864 15.164 5.89169C15.9961 6.45236 16.6 7.29096 16.6 8.29545V12.3386H15.4V8.29545C15.4 7.81071 15.1089 7.30158 14.4935 6.88683C13.8815 6.47446 13.0019 6.2 12 6.2C10.9981 6.2 10.1185 6.47446 9.50654 6.88683ZM7 19.0773C6.45 19.0773 6 18.774 6 18.4034V13.0125C6 12.6419 6.45 12.3386 7 12.3386H17C17.55 12.3386 18 12.6419 18 13.0125V18.4034C18 18.774 17.55 19.0773 17 19.0773H7ZM12.6 16.3818C12.6 16.0504 12.3314 15.7818 12 15.7818C11.6686 15.7818 11.4 16.0504 11.4 16.3818V17.0557C11.4 17.387 11.6686 17.6557 12 17.6557C12.3314 17.6557 12.6 17.387 12.6 17.0557V16.3818Z",
            fill: components_system_colors__WEBPACK_IMPORTED_MODULE_1__/* .cssColorValues */ .b[color]
        })
    });
};


/***/ }),

/***/ 38194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a8": function() { return /* binding */ difficultyLevelOptions; },
/* harmony export */   "gw": function() { return /* binding */ difficultyLevelColors; },
/* harmony export */   "l9": function() { return /* binding */ difficultyLevels; },
/* harmony export */   "vz": function() { return /* binding */ difficultyLevelNames; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var difficultyLevels = {
    Easy: 1,
    Medium: 2,
    Hard: 3
};
var _obj;
var difficultyLevelNames = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, difficultyLevels.Easy, "Easy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, difficultyLevels.Medium, "Medium"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, difficultyLevels.Hard, "Hard"), _obj);
var _obj1;
var difficultyLevelColors = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, difficultyLevels.Easy, "green"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, difficultyLevels.Medium, "orange"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, difficultyLevels.Hard, "red"), _obj1);
var difficultyLevelOptions = [
    {
        value: difficultyLevels.Easy,
        label: difficultyLevelNames[difficultyLevels.Easy]
    },
    {
        value: difficultyLevels.Medium,
        label: difficultyLevelNames[difficultyLevels.Medium]
    },
    {
        value: difficultyLevels.Hard,
        label: difficultyLevelNames[difficultyLevels.Hard]
    }, 
];


/***/ }),

/***/ 65082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"main_course_cta_card__7wuKM","imageWrapper":"main_course_cta_imageWrapper__2Wh35","description":"main_course_cta_description__6B5mY","contentPreview":"main_course_cta_contentPreview__Nh6HW","buttonWrapper":"main_course_cta_buttonWrapper__cpi3A","titleDiv":"main_course_cta_titleDiv__wMdx1","titleDivHeader":"main_course_cta_titleDivHeader__slhxd"};

/***/ }),

/***/ 28325:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"post_card_container__hqdv9","content":"post_card_content__Cjhm8","header":"post_card_header__PE405"};

/***/ }),

/***/ 95393:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"simple_course_section_list_linkWrapper__Me4qn","link":"simple_course_section_list_link__fcNqM","time":"simple_course_section_list_time__NT5Jv","alignLayout":"simple_course_section_list_alignLayout__Y3RrU"};

/***/ }),

/***/ 85285:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"question_link_list_container__DyAIS","link":"question_link_list_link__YgMDs","content":"question_link_list_content__ILR6a"};

/***/ }),

/***/ 5306:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"content_placeholder_container__1HHjG","line":"content_placeholder_line__GgkD0","shimmer":"content_placeholder_shimmer__0zTdV"};

/***/ }),

/***/ 51733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"track":"progress_bar_track__gK8zE","progress":"progress_bar_progress__aOJ1I","sm":"progress_bar_sm__pL9oP","md":"progress_bar_md__lJAy2","lg":"progress_bar_lg__HnS_G"};

/***/ })

}]);